import React from 'react';
import Header from './shared/Header';
import { getRandomColor } from '../utils/colors';
const GiovannittiPage = () => {
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/hy6HA997iomV6sCZmEL15i/Madeleine_Morlet_1.jpg'];
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-173">
      <Header data-id="element-174" />
      <div className="container mx-auto px-6 pt-24 pb-16" data-id="element-175">
        <div className="max-w-4xl mx-auto" data-id="element-176">
          {/* Image now appears first, matching the top alignment of MotherhoodStory */}
          <div className="mb-8" style={{
          paddingTop: '16vh'
        }} data-id="element-177">
            <img src={images[0]} alt="Giovannitti Needs God" className="w-full h-auto object-contain max-h-[70vh]" data-id="element-178" />
          </div>
          {/* Title and credits now appear below the image */}
          <div className="mb-8" data-id="element-179">
            <h1 className="text-base mb-4" data-id="element-180">
              Giovannitti Needs God (Interview, <em data-id="element-181">Badlon Magazine</em> 2025)
            </h1>
            <div className="text-sm leading-relaxed" data-id="element-182">
              Edited by{' '}
              <a href="https://www.instagram.com/anna_deppp" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#333333';
            }} data-id="element-183">
                @anna_deppp
              </a>
              <br data-id="element-184" />
              Portraits by{' '}
              <a href="https://www.instagram.com/s_o_p_h_i_e_" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#333333';
            }} data-id="element-185">
                @s_o_p_h_i_e_
              </a>
            </div>
          </div>
          <div className="text-base space-y-6" data-id="element-186">
            <p data-id="element-187">
              In the summer of 2023, I accidented on Sophia Giovannitti's debut
              book <em data-id="element-188">Working Girl: On Selling Art and Selling Sex</em>, which
              had been published by Verso that May. It was in the window display
              at Donlan Books near London Fields, where I had just walked with a
              friend.
            </p>
            <p data-id="element-189">
              My friend––a successful artist––and I––a heavily pregnant
              woman––had been discussing the current junctures of our lives. As
              I told her, "I'm preparing for the unpaid labor of early
              motherhood," she responded that her relationship with creative
              output and capitalism was ending. "I'll still lead a creative
              life, but I have to accept that I am an artist, not a
              businesswoman." Her career had always been covetable, and she
              still struggled to make ends meet. Additionally, the hustle to
              survive off of art had taken the pleasure out of making art. In
              surveying alternate income avenues, she turned to women's work.
              She told me, "I've reached out to a few local strip clubs, but no
              one has responded. Maybe I'm too old?" And then, as her gaze
              quickly passed over my body, "Are any of your friends looking for
              childcare?"
            </p>
            <p data-id="element-190">
              Both indirectly and directly, Giovannitti's writing would speak to
              this.
            </p>
            <div className="text-center" data-id="element-191">*</div>
            <p data-id="element-192">
              Sophia Giovannitti (b. 1992) is a conceptual artist based in New
              York whose practice includes writing, video, performance, and
              sculpture under the umbrella of Studies. She has a bachelor's
              degree in religion from Hunter College—an interesting biographical
              fact, as her most recent show at Lower East Side's Blade Study,{' '}
              <em data-id="element-193">You Know I Got It So Come and Get It</em> (2024), included a
              two-hour live lecture titled{' '}
              <em data-id="element-194">Does It Have a Sincere Relationship to God?</em>
            </p>
            <p data-id="element-195">This exhibition is now closed.</p>
            <p data-id="element-196">
              Before meeting with me over Zoom, she shared a transcript of her
              lecture. It is here that I witnessed the artist transform into a
              cowboy, voyaging through an American cultural landscape in search
              of meaning. She later tells me, "Obviously, this is an age-old
              story, man's search for meaning, a cowboy's search for God. I'm
              certainly not the first to ask, what does this all mean?"
            </p>
            <p data-id="element-197">
              Her professional life as an artist and a sex worker had led her to
              a crisis of faith––in part, a response to an inciting incident in
              which the boundaries between sexual labor and corporate labor
              collapsed. This will be the subject of her next book. Her first
              book, <em data-id="element-198">Working Girl</em>, was also an exploration of labor. It
              questions how two industries that sell themselves on a necessary
              separation from the marketplace can exist within the contradiction
              of being lucrative to the marketplace. As a character, her
              narrative arc, or the evolution of her practice, speaks to the
              themes of this issue: love, sex, and soul. Through personal
              reflection, critical pastiche, and serendipity, Giovannitti turns
              from nihilism to something like God––devotion.
            </p>
            <p data-id="element-199">
              In the final chapter of <em data-id="element-200">Working Girl</em>, titled{' '}
              <em data-id="element-201">On Meaning, Part II</em>, Giovannitti writes, "I text my
              boyfriend from the other room, "Am I a worker?" I am reading
              Marxist theory, and I am confused. I don't understand whether or
              not I own my means of production; I'm not sure what it means when
              you use your labor power to sell a commodity if that commodity is,
              in the end, your self."
            </p>
            <p data-id="element-202">
              Central to the thesis of Giovannitti's ongoing theoretical
              investigations are questions of labor under empire. I think about
              this thesis through the lens of motherhood. Marxism acknowledges
              reproductive labor as that which produces the labor force. As I
              skim through the notes from our interview, I want to text
              Giovannitti, "I am referencing Marxist theory, and I am not sure
              what it means." We haven't exchanged numbers. I can't help but
              think about the labor of women within the binary of the
              Madonna-whore complex, in which women who earn money from their
              bodies are penalized societally, and women who produce the labor
              force from their bodies are penalized economically. Much of
              women's work––a loaded term which in this context specifically
              references the work of reproduction, pleasure, or care––is unpaid
              or underpaid. According to Oxfam International, the value of this
              shadow labor is approximately $10.9 trillion a year.
            </p>
            <p data-id="element-203">
              I am interested in how Giovannitti relates to the body as an
              object for sale, and how she is able to tie this to the
              theoretical framework of contemporary art history. She tells me,
              "When I started this exploration of sex and art, and the
              relationship between the two, I was interested in coming at it
              from what I would say was a materialist perspective. These things
              have always been connected metaphorically, but in what ways are
              they actually connected? Economically, artists are selling sex to
              fund the production of their art, but also there's an intersection
              between these two industries. Part of the experience of putting
              out <em data-id="element-204">Working Girl</em> is the feeling that you can have radical
              ideas and anti-capitalist desires, but we live in this really
              oppressive system that swallows all of us."
            </p>
            <p data-id="element-205">
              Extending herself beyond the body, Giovannitti discusses how her
              recent work examines the sale of our souls through the
              commodification of our identities. "Art and writing, and any kind
              of radical identity production or cultural production, at this
              point is immediately assimilated into the status quo (or the arms
              of empire). I feel like I just zoomed out. I was reading thinkers
              and theorists, like autonomous Marxist philosophers, who argue
              that the way value is produced today and the site of the labor
              struggle is no longer the factory but the production of culture,
              and the production of the conditions we live under, and the
              production of consciousness itself. I started to really agree.
              Everyone is in this constant culture war that has so much to do
              with identity and cultural production. I started to move away from
              this materialist analysis and reason for making art. What is the
              point of producing art if I no longer think my interventions will
              change or upend the totalizing systems? Why am I doing it?"
            </p>
            <p data-id="element-206">
              Giovannitti is brilliant in her ability to articulate complex
              ideas and esoteric subject matter with an absence of gratuitous
              detail and a touch of humor. In her lecture,{' '}
              <em data-id="element-207">Does It Have a Sincere Relationship to God?</em> I read about
              two articles of clothing she had hung on the gallery walls. Her
              boyfriend's black Tommy Gun T-shirt, inside out, and black
              trousers made by an obscure 90s Japanese brand, Bio-politics. In
              Alana Pockros' review of the show on ArtReview,{' '}
              <em data-id="element-208">Sophia Giovannitti: Be the Cowboy</em>, I discover that she
              took these clothes from the wall and changed into them in front of
              her audience as an illustration of her shift from form-fitting to
              baggy clothing since publicly exposing herself as a sex worker.
              "If everyone knows you're a whore, you might as well leave
              something to the imagination." During this live performance, she
              dissected the reviews of <em data-id="element-209">Working Girl</em>, an intimate
              illustration of the constant culture wars of the moment that
              prevent interventions for change. Too radical. Not radical enough.
              Activism representing an oppressed community. A complete betrayal
              of this said community. "I tied myself to a public identity, and I
              grew to hate the rope." Nihilism has Giovannitti question, "Why am
              I doing it?" It is her restoration of faith that asks instead,
              "How can I make something meaningful?" She tells me, "I started
              looking at choreographers and feminist conceptual artists, people
              dealing with ideas of devotion and different ways to position
              yourself in relationship to culture and relationship to other
              artists. I landed on this idea of devotion, which has always been
              a driving force in my work."
            </p>
            <p data-id="element-210">I ask, "Do you have a sincere relationship with God?"</p>
            <p data-id="element-211">Giovannitti says, "I think that I do. Definitely."</p>
            <p data-id="element-212">"What does this relationship look like?"</p>
            <p data-id="element-213">
              "A lot of it is in my work. When I was younger, my focus on
              materialism was a way to dedicate my life to particular creative
              pursuits. I am still very interested in those materialist
              questions, but having lived this kind of life for several years,
              I've realized that it is much deeper than that for me. For me,
              devotion is a Godly orientation, a divine thing in your day-to-day
              life. I practice devotion through writing, making art, being
              devoted to particular ideas, in relationships, to my partner, pet,
              friend. I'm not saying you can find God in everything, but I guess
              you kind of can."
            </p>
            <p data-id="element-214">
              I respond, "This brings me to the idea of true love as the
              practice of making art, that true love is an act of surrender and
              acceptance. In this way, the act of making cannot be controlled."
            </p>
            <p data-id="element-215">
              "I completely agree. Increasingly, in artistic practice and
              otherwise, what interests me is how can things transform through
              grace and devotion?"
            </p>
            <p data-id="element-216">
              The artist transforms. I turn back to the transcripts of her
              lecture, where I find Giovannitti continuing this thread. She
              explains the use of the cowboy as a metaphor that both searches
              for and discovers, "The process [...] of my loss of faith made me
              want autonomous singularity so badly [...] I didn't want to be a
              whore among whores, a woman among women, or in the end, a human
              among humans. I wanted only to be a cowboy." Here, she can
              acknowledge that even the cowboy is never alone in their
              questioning. "Just as there is the other side of language, there
              is the other side of the cowboy, and after my faith completely
              left me, I emerged through this other side. There is always one
              end of the stick and there is also always the other. There is true
              autonomy and with true autonomy comes true dependency; with the
              cowboy comes the horse." Like the mother with her child, the
              dancer with their body, and the artist with their practice, this
              connection to devotion––through the act of making, through art,
              sex, and relationships––is love.
            </p>
            <div className="text-center" data-id="element-217">*</div>
            <p data-id="element-218">
              A year after I stumbled across Sophia Giovannitti's debut book, I
              met with the same friend for an artist's talk at The
              Photographer's Gallery in Soho.
            </p>
            <p data-id="element-219">
              My friend––now working at the Royal Mail and leading a creative
              life for pleasure––and I––now a mother of two––listen to the
              artist on stage as she tells us about the current juncture of her
              life. The artist says, in her former work as a psychotherapist and
              within her current practice as a photographer, she has noticed a
              pattern, "If we are to turn away from something that needs
              attention, eventually that thing will create a rupture so great
              that we have no option but to face it." After a pause, she
              continues, "What has saved me is a belief in something greater
              than myself, my relationship with God."
            </p>
            <p data-id="element-220">
              Later that night, I was texting my friend about the artist profile
              I would write on Giovannitti, and she sent me a Japanese meme—a
              busty anime figure on her knees with the text
              "精神的な無神論者の女の子には神が必要だ." This apparently
              translates to "spiritual atheist girl needs God."
            </p>
            <div className="mb-32" data-id="element-221"></div>
          </div>
        </div>
      </div>
    </div>;
};
export default GiovannittiPage;